<template>
  <div
    class="el-popper region-dropdown"
    :class="{'hq-region-dropdown':HQ}"
    :style="{ width: '564px' }"
  >
    <div class="menu-box">
      <div class="city-content">
        <div
          class="area-menu-item"
          @click="selectAll"
          :class="checkAll() ? 'region-item selected' : 'region-item'"
          v-if="!map"
        >
          <span>全国</span>
        </div>
        <div
          class="area-menu-item region-item"
          :class="[{'selected' : check(item.value,1)},{'notChoose':notChoose(item.value)}]"
          @click="onSelect(item.value)"
          v-for="(item, index) in locationOptions.hot"
          :key='index'
        >
          <span>{{item.label}}</span>
        </div>
        <template v-if="!map">
          <div
            class="button2"
            @click="confirm"
          >确定</div>
          <div
            class="button1"
            @click="cancelSelect"
          >清空</div>
        </template>
      </div>
      <div class="city-content">
        <div
          class="area-menu-item code-item"
          v-for="(item, index) in codeMap"
          :key='index'
          :class="{'first-code':index==0}"
          @click="cityScrollTo(index)"
        >
          <span>{{item}}</span>
        </div>
        <div
          class="searchWrap"
          id="searchInputWrap"
        >
          <div
            class="search"
            id="userDeInput1"
          >
            <el-autocomplete
              ref='auto'
              style="width: 606px;"
              v-model="keyword"
              :trigger-on-focus="true"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              placeholder="输入省份或城市名"
            >
              <template slot-scope="props">
                <div
                  class="name"
                  v-html="props.item.showText"
                ></div>
              </template>
            </el-autocomplete>
            <div
              class="del-btn"
              v-if="keyword!=''"
              @click="keyword=''"
            ></div>
            <div
              class="search-btn"
              @click="searchCity"
            >
              <div class="icon"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="city-list "
        ref="cityList"
      >
        <div
          class="city-item "
          v-for="(items, index) in locationOptions.normal"
          :key="index"
          :class="{'first-Group':index==0}"
        >
          <span
            class="proTitle area-menu-item"
            style="cursor:default"
          >{{items.code}}</span>
          <span
            :ref="'pro'+items.value"
            style="cursor:default"
            class="proName area-menu-item"
            :class="[{'longPro':items.value == '41'||items.value == '42' || items.value=='51'||items.value=='44'||items.value=='52'||items.value=='63'},{'shortPro':items.value=='35'||items.value=='46'||items.value=='54'||items.value=='64'},{'largePro':items.value=='46'||items.value=='51'||items.value=='53'},{'longgerPro':items.value == '65'}]"
          >
            <!-- :class="[{'longPro':items.value == '46' || items.value=='51'||items.value=='44'||items.value=='52'||items.value=='63'},{'shortPro':items.value=='35'||items.value=='46'||items.value=='54'||items.value=='64'},{'largePro':items.value=='53'||items.value=='65'}]" -->

            {{items.label}}:</span>
          <span
            class="allCity area-menu-item"
            @click="onSelect(items.value)"
            :class="[{'selected':check(items.value)},{'notChoose':notChoose(items.value)}]"
          >全部</span>
          <div
            class="area-menu-item region-item"
            :class="[ {'selected':check(item.cityCode)},{'notChoose':notChoose(item.cityCode)}]"
            @click="onSelect(item.cityCode,item)"
            v-for="(item, index) in items.city"
          >
            <span>{{item.cityName}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import { industryOptions, locationOptions, locationNumber } from '../../common/optionMap';
import { municipality } from '../../common/administrativeAreas';

export default {
  data () {
    return {
      timerId: null,
      locationOptions: locationOptions,
      locationNumber: locationNumber,
      keyword: '',
      codeMap: ['A', 'F', 'G', 'H', 'J', 'L', 'N', 'Q', 'S', 'X', 'Y', 'Z'],
      options: [],
      locationHeight: [0, 70, 116, 430, 786, 980, 1040, 1140, 1240, 1524, 1660, 1660],
      canChoose: [],
    };
  },
  inject: ['select'],
  props: ['value', 'querystring', 'map'],
  watch: {
    'select.visible' (val) {
      if (val) {
        this.canChoose = this.cloneDeep(this.initialLocation);
        this.options = this.cloneDeep(this.value);
        this.keyword = '';
      }
    }
  },
  computed: {
    initialLocation () {
      if (!this.querystring) return null;
      if (this.querystring.indexOf('}') != -1) {
        let form = JSON.parse(this.querystring);
        if (form.filter) {
          form.filter = JSON.parse(form.filter);
        }
        if (form.filter.location.length > 0) {
          return form.filter.location;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  },
  methods: {
    confirm () {
      this.$emit('input', this.options);
      this.select.handleClose();
    },
    cancelSelect () {
      this.options = [];
      this.keyword = '';
    },
    onSelect (val,item) {
      if (!this.notChoose(val)) {
        const index = this.options.indexOf(val);
        if (!this.map) {
          const index = this.options.indexOf(val);
          if (index == -1) {
            this.onSearch(val)
          } else {
            this.options.splice(index, 1);
          }
        } else {
          this.options = [val]
          this.confirm()
          // if(this.municipality.indexOf(val)>=0){
            this.$emit('slectMu',val)
          // }
          
        }
        if (this.options.length === 31) {
          let count = 0;
          this.options.forEach((e, i) => {
            if (e.length === 2) { count++ }
          });
          if (count === 31) { this.options = [] }
        }
      }
    },
    selectProvice (val) {
      /*去除省中的市*/
      let options = this.options.filter((e, i) => {
        return e.indexOf(val) !== 0;
      });
      this.options = options;
    },
    checkProvice (val) {
      /*检测是否选中全省*/
      let ptoValue = val.substring(0, 2);
      let num = 0;
      let index = '';
      this.options.forEach((e, i) => {
        if (e.indexOf(ptoValue) === 0) {
          num++;
        }
        /*确定省份是否已选中*/
        if (e.length === 2 && val.indexOf(e) === 0) {
          index = i;
        }
      });
      /*    console.log(val,ptoValue,index,num)*/
      if (num === this.locationNumber[ptoValue] - 1) {
        /*选中全省*/
        this.selectProvice(ptoValue);
        this.options.push(ptoValue);
      } else {
        if (index !== '') {
          this.options.splice(index, 1);
        }
        if (this.map) {
          this.options = [val]
          this.confirm()
        } else {
          this.options.push(val);
        }
      }
    },
    check (val, speIndex) {
      if (this.options.indexOf(val) != -1) {
        return true;
      }
      if (speIndex && val == '4401' && this.options.indexOf('44') != -1) {
        return true;
      }
    },
    selectAll () {
      this.options = [];
      console.log(this.options)
    },
    checkAll () {
      if (this.options.length === 0 && (!this.canChoose || this.canChoose.length === 0)) {
        return true
      }
    },
    cityScrollTo (index) {
      this.$refs.cityList.scrollTop = this.locationHeight[index];
    },
    querySearch (queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      let result = this.searchFilter(queryString);
      let searchResults = [];
      result.forEach((e, i) => {
        searchResults[i] = {};
        searchResults[i].value = e.value;
        searchResults[i].code = e.code;
        e.value = e.value.replace(queryString, '<em>' + queryString + '</em>');
        searchResults[i].showText = e.value;
        searchResults[i].scrollHeight = e.scrollHeight;
      });
      result = searchResults;
      cb(result);
    },
    handleSelect (item) {
      this.$emit('ChangeClose', false);
      window.clearTimeout(this.timerId);
      this.timerId = window.setTimeout(() => {
        this.$emit('ChangeClose', true);
      }, 50);
      if (!this.notChoose(item.code)) {
        if (this.options.indexOf(item.code) == -1) {
          this.onSearch(item.code)
        }
      }
      this.$refs.cityList.scrollTop = this.getScrollHeight(item.code);
    },
    searchCity () {
      let result = this.searchFilter(this.keyword);
      let searchCode = 0;
      result.forEach((e, i) => {
        if (e.value == this.keyword) {
          searchCode = e.code;
          return;
        }
      });
      if (searchCode) {
        if (!this.notChoose(searchCode)) {
          if (this.options.indexOf(searchCode) == -1) {
            this.onSearch(searchCode)
          }
        }
        this.$refs.cityList.scrollTop = this.getScrollHeight(searchCode);
      }
    },
    onSearch (val) {
      if (val.length === 2) {
        if (this.map) {
          // 选择直辖市直接去对应的城市
          this.options = [val]
          this.confirm()
        } else {
          /*选择省则去除对应的市*/
          this.selectProvice(val);
          this.options.push(val);
        }
      } else {
        /*选择市，检测是否选了全省*/
        this.checkProvice(val)
      }
    },
    getScrollHeight (code) {
      let newCode = (code.length === 2) ? code : code.slice(0, 2);
      let proRef = 'pro' + newCode;
      let scrollHeight = 0;
      if (this.$refs[proRef]) {
        scrollHeight = this.$refs[proRef][0].offsetTop - 95;
      }
      return scrollHeight;
    },
    searchFilter (queryString) {
      let result = [], j = 0;
      this.locationOptions.normal.forEach((e, i) => {
        let scrollHeight = 0;// e.scrollHeight;
        if (e.label.indexOf(queryString) !== -1) {
          result[j] = {};
          result[j].code = e.value;
          result[j].value = e.label;
          result[j].scrollHeight = scrollHeight;
          j++;
        }
        e.city.forEach((e, i) => {
          if (e.cityName.indexOf(queryString) !== -1) {
            result[j] = {};
            result[j].code = e.cityCode;
            result[j].value = e.cityName;
            result[j].scrollHeight = scrollHeight;
            j++;
          }
        })
      });
      this.locationOptions.hot.forEach((e, i) => {
        if (e.label.indexOf(queryString) !== -1) {
          result[j] = {};
          result[j].code = e.value;
          result[j].value = e.label;
          result[j].scrollHeight = 0;
          j++;
        }
      });
      return result;
    },
    notChoose (val) {
      if (this.canChoose && this.canChoose.length > 0) {
        let pro = '';
        if (val.length == 4) { pro = val.slice(0, 2); }
        if (this.canChoose.indexOf(val) == -1 && this.canChoose.indexOf(pro) == -1) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../../static/css/searchInput.css";
@import "../../assets/stylesheets/regionOld";
.notChoose,
.city-list .city-item .allCity.notChoose {
  color: #999;
  cursor: not-allowed !important;
}
.notChoose:hover,
.city-list .city-item .allCity.notChoose:hover {
  color: #999 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/clickSelect/region.vue